import { all, put, takeLatest } from 'redux-saga/effects';
import { requestApi2 } from '../../../../../lib/request';
import * as action from '../actions';
import { constants, services } from '../config';

export function* getPrivacySaga({ lang }) {
  try {
    const response = yield requestApi2(services.getPrivacy(lang));
    if (response && response.status >= 200 && response.status < 300) {
      yield put(action.getPrivacySuccess(response.data));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.getPrivacyFail(error));
  }
}

function* actionWatcher() {
  yield takeLatest(constants.GET_PRIVACY, getPrivacySaga);
}

export default function* defaultSaga() {
  yield all([actionWatcher()]);
}
